import { Button, FormControl, InputLabel, OutlinedInput, Stack } from "@mui/material";
import * as React from "react";
import Modal, { CommonModalProps } from "..";
import { useTranslation } from "react-i18next";

export type ModalSaveBasketElementProps = {
  onClose?: () => void;
  onSaveBasket: (title: string) => void;
};

export type ModalSaveBasketProps = CommonModalProps<ModalSaveBasketElementProps>;

const ModalSaveBasket = React.forwardRef<any, ModalSaveBasketProps>((_props, ref) => {
  const { closeModal, onClose, onSaveBasket } = _props;
  const [title, setTitle] = React.useState<string>("");
  const { t } = useTranslation();

  const handleCancelClick: React.MouseEventHandler = () => {
    onClose && onClose();
    closeModal();
  };

  const onClickSave = () => {
    onSaveBasket(title);
    onClose && onClose();
    closeModal();
  };

  return (
    <Modal
      title={t("modal:title.saveBasket")}
      reference={ref}
      closeModal={closeModal}
      width={504}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button variant="contained" onClick={() => onClickSave()} disabled={title.length < 1}>
            {t("common:saveBasket")}
          </Button>
        </Stack>
      }
    >
      <FormControl>
        <InputLabel shrink htmlFor="basketName">
          {t("field:label.basketName")}
        </InputLabel>
        <OutlinedInput
          id="firstname"
          onChange={(e) => {
            setTitle(e.target.value);
          }}
        />
      </FormControl>
    </Modal>
  );
});

export default ModalSaveBasket;
